import { useId } from 'react';
import clsx from 'clsx';
import { Radio } from '@/components/icons';
import { Toggle } from '@/components/ui';
import type { LiveToggleState } from '@/lib/liveView';

/** "Watch live" switch shown next to run buttons. Live view is opt-in per run. */
export function WatchLiveToggle({
  state,
  onChange,
  className,
}: {
  state: LiveToggleState;
  onChange: (on: boolean) => void;
  className?: string;
}) {
  const hintId = useId();
  return (
    <div
      className={clsx('inline-flex items-center gap-2 text-sm', !state.available && 'opacity-70', className)}
      title={state.available ? 'Watch the browser while the test runs' : state.reason}
    >
      <Toggle checked={state.checked} onChange={onChange} label="Watch live" disabled={!state.available} />
      <span className="inline-flex items-center gap-1 font-medium text-slate-700 dark:text-slate-200" aria-hidden="true">
        <Radio className="size-4 text-rose-500" /> Watch live
      </span>
      {!state.available && state.reason && (
        <span id={hintId} className="sr-only">
          {state.reason}
        </span>
      )}
    </div>
  );
}
